import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div className="flex flex-col gap-1">
        <h2 className="flex items-center gap-2 text-lg font-bold text-foreground-950 md:text-xl">
          <span className="inline-block h-5 w-1 rounded-full bg-accent-500" aria-hidden="true"></span>
          {title}
        </h2>
        {subtitle && (
          <p className="pl-3 text-xs text-foreground-500 md:text-sm">
            {subtitle}
          </p>
        )}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex items-center gap-1 whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-primary-600 md:text-sm"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}